var config={
  host:"http://localhost:9993/",
  timeout:120,
  max:10,
  fee:0.10
}
export default config;
